// extracted by mini-css-extract-plugin
export default {"btn":"PastReservationsRow_btn__iNLxd","table-number-cell":"PastReservationsRow_table-number-cell__MMXsz","tr":"PastReservationsRow_tr__BNYvm"};